import { render, staticRenderFns } from "./BirthdayMonth.vue?vue&type=template&id=04e30cce"
import script from "./BirthdayMonth.vue?vue&type=script&lang=js"
export * from "./BirthdayMonth.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports